<script lang="ts">
    import { MainWrapper } from '@components/layout/main-wrapper';
    import { LL } from '@i18n/i18n-svelte';
    import { APP_NAME } from '@shared/constants';
    import { Font, FontTypes } from '@uikit/font';

    import s from './page.module.css';
</script>

<MainWrapper>
    <div class={s.root}>
        <div class={s.alertIcon}>!</div>
        <Font
            type={FontTypes.Type.h3}
            color={FontTypes.Color.Invert}
            tagName={FontTypes.TagName.h3}
            isBold
            className={s.title}
        >
            {@html $LL.unsupportedDevice.title({ appName: APP_NAME })}
        </Font>
        <Font
            type={FontTypes.Type.body}
            color={FontTypes.Color.Invert}
            tagName={FontTypes.TagName.p}
            className={s.description}
        >
            {$LL.unsupportedDevice.description()}
        </Font>
    </div>
</MainWrapper>
